import { QueryClient } from '@tanstack/react-query';

/**
 * Central server-state cache. TanStack Query replaces the manual re-render /
 * localStorage syncing that plagued V1 — data fetching, caching, and
 * invalidation become declarative.
 */
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 30_000,
      gcTime: 5 * 60_000,
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});

/** Typed query-key factory — keeps cache keys consistent and refactor-safe. */
export const queryKeys = {
  session: ['session'] as const,
  profile: (id: string) => ['profile', id] as const,
  profileByHandle: (handle: string) => ['profile', 'handle', handle] as const,
  communities: {
    all: ['communities'] as const,
    list: (filters?: Record<string, unknown>) => ['communities', 'list', filters ?? {}] as const,
    byOwner: (ownerId: string) => ['communities', 'owner', ownerId] as const,
    detail: (id: string) => ['communities', 'detail', id] as const,
    members: (id: string) => ['communities', id, 'members'] as const,
  },
  chat: {
    messages: (communityId: string, channelId: string) =>
      ['chat', communityId, channelId] as const,
  },
  wallet: (userId: string) => ['wallet', userId] as const,
  friends: (userId: string) => ['friends', userId] as const,
  userCommunities: (userId: string) => ['communities', 'member', userId] as const,
} as const;
